import React, { useContext, useEffect, useMemo, useState } from 'react';
import WelcomeScreen from '../components/ua-hostess/welcome-screen';
import styles from '../components/lm-d-s/index.module.scss';
import { ScreensContext } from '../contexts/screensContext';
import ErrorPage500 from '../components/ua-hostess/error-page-500';
import FormScreen from '../components/ua-hostess/form-screen';
import OtpScreen from '../components/ua-hostess/otp-screen';
import AlreadyRegistered from '../components/ua-hostess/already-registered';
import SuccessRegistered from '../components/ua-hostess/success-registered';
import ErrorPage404 from '../components/ua-hostess/error-page-404';
import AttemptsExhausted from '../components/ua-hostess/attempts-exhausted';
import GeoresctrictionScreen from '../components/ua-hostess/georesctriction-screen';
import { DataLayerEventContext } from '../contexts/dataLayerEventContext';
import useScreenHistory from '../hooks/useScreenHistory';

const utm_campaign = sessionStorage.getItem('utm_campaign');
const utm_event = sessionStorage.getItem('utm_event');
const utm_medium = sessionStorage.getItem('utm_medium');
const utm_source = sessionStorage.getItem('utm_source');
const utm_source_id = sessionStorage.getItem('utm_source_id');
const utm_partner = sessionStorage.getItem('utm_partner');

const UAHostess = ({ isNewProductFlow = false, handleBackToMenu = null }) => {
  const params = {
    utm_campaign,
    utm_event,
    utm_medium,
    utm_source,
    utm_source_id
  };
  const { sendEvent, init } = useContext(DataLayerEventContext);
  const [formData, setFormData] = useState({});
  const { screenNumber, setScreenNumber } = useScreenHistory({
    initialScreen: 1
  });
  const [endSessionType, setEndSessionType] = useState('SESSION_END');
  const [isDisplayedAll, setIsDisplayedAll] = useState(false);
  const telegramLink = useMemo(
    () =>
      utm_source === 'HOSTESS' && !!utm_source_id && !!utm_partner
        ? `https://t.me/pmu_support_bot?start=CDA_Hstss${utm_source_id}_atb`
        : utm_source === 'HOSTESS' && !!utm_source_id && !utm_partner
          ? `https://t.me/pmu_support_bot?start=CDA_Hstss${utm_source_id}`
          : utm_source === 'SALESAGENT' && !!utm_source_id
            ? `https://t.me/pmu_support_bot?start=CDA_ActInf${utm_source_id}`
            : isNewProductFlow
              ? `https://t.me/pmu_support_bot?start=ScnPck-${utm_source_id}`
              : 'https://t.me/pmu_support_bot',
    [utm_source, utm_source_id]
  );

  useEffect(() => {
    init('ua-hostess');
  }, []);

  const getScreen = (number, cb) => {
    switch (number) {
      case 1: {
        return (
          <WelcomeScreen
            onTelegramHandleClick={() => {
              sendEvent('telegram_hostess');
            }}
            setScreenNumber={setScreenNumber}
            handleNextScreen={() => {
              sendEvent('registration');
              setScreenNumber(2);
            }}
            telegramLink={telegramLink}
            isPartner={!!utm_partner}
          />
        );
      }
      case 2: {
        return (
          <FormScreen
            params={params}
            setScreenNumber={setScreenNumber}
            onTelegramHandleClick={() => {
              sendEvent('telegram_hostess');
            }}
            backButtonClick={() => setScreenNumber(1, true)}
            telegramLink={telegramLink}
            setFormData={(data) => setFormData(data)}
            formData={formData}
          />
        );
      }
      case 3: {
        return (
          <OtpScreen
            params={params}
            setScreenNumber={setScreenNumber}
            telegramLink={telegramLink}
            handleChangePhoneNumber={() => setScreenNumber(2)}
            successSendOtp={() => {
              sendEvent('passed_authorization');
              setScreenNumber(5);
            }}
            onTelegramHandleClick={() => {
              sendEvent('telegram_hostess');
            }}
          />
        );
      }
      case 4: {
        return (
          <AlreadyRegistered
            handleBackToMenu={handleBackToMenu}
            setScreenNumber={setScreenNumber}
            telegramLink={telegramLink}
            onTelegramHandleClick={() => {
              sendEvent('telegram_hostess');
            }}
          />
        );
      }
      case 5: {
        return (
          <SuccessRegistered
            handleBackToMenu={handleBackToMenu}
            setScreenNumber={setScreenNumber}
            telegramLink={telegramLink}
            isPartner={!!utm_partner}
            onTelegramHandleClick={() => {
              sendEvent('telegram_hostess');
            }}
          />
        );
      }
      case 6: {
        return (
          <AttemptsExhausted
            setScreenNumber={setScreenNumber}
            telegramLink={telegramLink}
            onTelegramHandleClick={() => {
              sendEvent('telegram_hostess');
            }}
          />
        );
      }
      case 7: {
        return (
          <GeoresctrictionScreen
            setScreenNumber={setScreenNumber}
            telegramLink={telegramLink}
            onTelegramHandleClick={() => {
              sendEvent('telegram_hostess');
            }}
          />
        );
      }
      case 500: {
        return (
          <ErrorPage500
            setScreenNumber={cb}
            onTelegramHandleClick={() => {
              sendEvent('telegram_hostess');
            }}
          />
        );
      }
      case 404: {
        return (
          <ErrorPage404
            setScreenNumber={cb}
            onTelegramHandleClick={() => {
              sendEvent('telegram_hostess');
            }}
          />
        );
      }
      default: {
        return (
          <ErrorPage404
            setScreenNumber={cb}
            onTelegramHandleClick={() => {
              sendEvent('telegram_hostess');
            }}
          />
        );
      }
    }
  };

  return (
    <div className={styles.pageContainer} id="ua-hostess">
      <div className={styles.contentContainer}>
        <ScreensContext.Provider
          value={{
            endSessionType,
            setEndSessionType,
            isDisplayedAll,
            setIsDisplayedAll
          }}
        >
          {getScreen(screenNumber, setScreenNumber)}
        </ScreensContext.Provider>
      </div>
    </div>
  );
};

export default UAHostess;
